<template>
  <Modal class="modal" @close="close" special="special">
    <div class="modal__shields">
      <ModalShield icon="book" />
    </div>

    <div class="content">
      <ModalShield icon="swords" class="shield--active" />
      <span>Побеждайте врагов, чтобы прокачиваться</span>
      <ModalShield icon="numbers" class="shield--active" />
      <span>Не нападайте, если враг сильнее</span>
      <ModalShield icon="towers" class="shield--active" />
      <span>
        Перемещаться можно только между соседними башнями, зато между любыми
        этажами
      </span>
      <ModalShield icon="floor" class="shield--active" />
      <span>На один этаж нельзя попасть дважды</span>
    </div>
  </Modal>
</template>

<script>
import Modal from "./Modal";
import ModalShield from "./ModalShield";

export default {
  components: { Modal, ModalShield },
  methods: {
    close() {
      this.$store.commit("toggleModal", "howToPlay");
    }
  }
};
</script>

<style lang="scss" scoped>
.content {
  width: 100%;
  padding: 16px 32px 0;
  display: grid;
  grid-template: auto / auto 1fr;
  row-gap: 16px;
  column-gap: 27px;

  font-size: 1.13333rem;
  line-height: 1.2;

  text-align: left;
  align-items: center;
  justify-items: flex-start;

  @include mobile {
    padding: 0;
    column-gap: 19px;
    font-size: 1rem;
  }

  .shield {
    width: 70px;

    @include mobile {
      width: 50px;
    }
  }
}
</style>
